import React from 'react';
import styles from './css/Shorts.module.css';

const ShortCard = ({ short }) => {
  return (
    <div className={styles.shortCard}>
      <div className={styles.thumbnailContainer}>
        <img 
          src={short.thumbnail} 
          alt={short.title} 
          className={styles.thumbnail}
        />
        <button className={styles.playButton}>
          <div className={styles.playIcon}></div>
        </button>
      </div>
    </div>
  );
};

export default ShortCard;